import { type FormikErrors } from 'formik'

import { Field } from '@loadsmart/miranda-react'

import { type ScheduleFormValues } from '../../domain/Shipment'

export function ErrorMessage({
  validationStatus,
  errors,
  fieldName,
}: {
  validationStatus: string
  errors: FormikErrors<ScheduleFormValues>
  fieldName: keyof ScheduleFormValues
}) {
  if (validationStatus === 'danger') {
    return <Field.Hint>{errors[fieldName]}</Field.Hint>
  }

  return null
}
